import React, { useContext } from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const PhoneInputField = ({ formik, contextValue, disabled = false }) => {
  const { countryCode, languageData } = useContext(contextValue)
  const { values, setValues, setFieldTouched, errors, touched } = formik
  const hasError = errors?.phone && touched?.phone
  return (
    <PhoneInput
      name='phone'
      type='text'
      disabled={disabled}
      containerClass='phoneInputContainer'
      inputClass={`phoneInputClass ${hasError ? 'input-error' : ''}`.trim()}
      aria-describedby='emailHelp'
      alwaysDefaultMask={false}
      enableSearch
      placeholder={languageData?.phonePlaceholder}
      enableLongNumbers
      country={countryCode?.toLowerCase() || 'us'}
      onChange={(phone, code) => {
        const dial = String(code?.dialCode || '')
        const newPhone = phone.substring(dial.length)
        const newCode = '+' + dial
        setValues({ ...values, phone: newPhone, phoneCode: newCode })
      }}
      onBlur={() => setFieldTouched('phone', true)}
      buttonStyle={{ backgroundColor: '#22214b' }}
      inputStyle={{ width: '100%' }}
    />
  )
}

export default PhoneInputField
